import { Box } from '@mui/material';
import React from 'react';
import DetailedSellerReportContainer from '../../containers/DetailedSellerReportContainer';

export default function DetailedSellerReport() {
  return (
    <Box>
      <DetailedSellerReportContainer />
    </Box>
  );
}
